// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Le thème est monté par App.jsx (`src/theme.js`). Ne pas en monter un second
// ici : deux CssBaseline écriraient chacun le fond du body, et le gagnant ne
// dépendrait que de l'ordre d'injection des styles.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
